import * as React from 'react';
import { useMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import t from '../../shared/translations';
import LockedModal, { useLockedModal } from '../LockedModal';
import Error from '../components/Error';
import WithTasksSidebar from '../tasksSidebar';
import TaskChoiceDescription from './TaskChoiceDescription';
import { IArgs, IData, query } from './query';

const Wrapper = styled.main`
    padding: 0 15px;
    flex-grow: 1;
    max-width: 1440px;
    width: 100%;
`;

function PathInPath(): JSX.Element {
    const { params: { id } } = useMatch({ path: '/task-choice/:id/' });
    const { openLockedModal, ...lockedProps } = useLockedModal();
    const [result] = useQuery<IData, IArgs>({
        query,
        variables: { id },
    });
    if (result.fetching) {
        return <Wrapper>
            <Loader />
        </Wrapper>;
    } else if (result.error) {
        return <Wrapper>
            <Error />
        </Wrapper>;
    }
    const taskChoice = result.data.taskChoice;
    return <Wrapper>
        <WithTasksSidebar
            openLockedModal={openLockedModal}
            path={taskChoice.learningPathItem.learningPath}
            activeItem={taskChoice.learningPathItem.id}
            mainLabel={t('player.task-choice.tab-task-choice')}
            big={true}
        >
            <TaskChoiceDescription taskChoice={taskChoice} />
        </WithTasksSidebar>
        <LockedModal {...lockedProps} />
    </Wrapper>;
}

export default PathInPath;
